import React from 'react';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import DescriptionList from "../shared/DescriptionList";
import DescriptionItem from "../shared/DescriptionItem";
import config from "../config";
import moment from "moment";


function ShiftPaymentSummary(props) {
  const {classes, shift} = props;

  // Calculations
  const startTimeMoment = moment(shift.start_time);
  const endTimeMoment = moment(shift.end_time);
  const hours = endTimeMoment.diff(startTimeMoment, 'minutes') / 60;

  const totalWage = shift.wage * hours;
  const singleShiftFees = config.ratePerShift
  const totalPerPro = totalWage + singleShiftFees;
  const total = (totalWage + singleShiftFees) * shift.required_pros

  // Strings
  const hoursString = `${hours.toFixed(2)} hours`
  const wageString = `$${shift.wage}`
  const totalWageString = `$${totalWage.toFixed(2)}`;
  const singleshiftFeeString = `$${singleShiftFees.toFixed(2)}`;
  const totalPerProString = `$${totalPerPro.toFixed(2)}`
  const numProsString = `${shift.required_pros}`
  const totalString = `$${total.toFixed(2)}`;

  return (
    <section className={classes.detailSection}>
      <Typography className={classes.title} variant={'subheading'}>Payment</Typography>
      <DescriptionList>
        <DescriptionItem term={'Duration'} details={hoursString} />
        <DescriptionItem term={'Wage'} details={wageString} operator={'x'}/>
        <DescriptionItem term={'Total Wages'} details={totalWageString}/>
        <DescriptionItem term={'SingleShift'} details={singleshiftFeeString} operator={'+'}/>
        {shift.required_pros != 1 &&
          <div>
            <DescriptionItem term={'Total Per Pro'} details={totalPerProString}/>
            <DescriptionItem term={'Number of Pros'} details={numProsString} operator={'x'} spaceBefore={true}/>
          </div>
        }
        <DescriptionItem term={'Total'} details={totalString} spaceBefore={true}/>
      </DescriptionList>
      <Typography className={classes.chargeOnFill} variant={'body2'}>You will only be charged if your shift is filled.</Typography>
    </section>
  )
}

const styles = (theme) => ({
  detailSection: {
    marginBottom: theme.spacing.unit * 4,
  },
  title: {
    marginBottom: theme.spacing.unit * 2,
    fontWeight: 'bold',
  },
  chargeOnFill: {
    marginTop: theme.spacing.unit * 2,
  }
});

export default withStyles(styles)(ShiftPaymentSummary);



// WEBPACK FOOTER //
// ./src/parts/ShiftPaymentSummary.js